/**
 * Sık yapılan e-posta alan adı yazım hatalarını yakalar (örn. icloid.com → icloud.com).
 * Yalnızca öneridir: adres doğruysa kullanıcı öneriyi yok sayabilir.
 */

const POPULAR_DOMAINS = [
  'gmail.com', 'hotmail.com', 'outlook.com', 'icloud.com', 'yahoo.com', 'yandex.com',
  'live.com', 'msn.com', 'hotmail.com.tr', 'outlook.com.tr', 'yahoo.com.tr', 'windowslive.com',
  'mynet.com', 'me.com', 'mac.com',
];

/** Popüler adreslere çok benzeyen ama gerçek olan sağlayıcılar — bunlara öneri çıkmaz */
const KNOWN_DOMAINS = new Set([
  ...POPULAR_DOMAINS,
  'mail.com', 'gmx.com', 'gmx.net', 'gmx.de', 'aol.com', 'proton.me', 'protonmail.com', 'pm.me',
  'yandex.ru', 'ya.ru', 'mail.ru', 'hotmail.de', 'hotmail.fr', 'hotmail.co.uk', 'live.de',
  'live.co.uk', 'outlook.de', 'yahoo.de', 'yahoo.fr', 'yahoo.co.uk', 'ymail.com', 'zoho.com',
  'tutanota.com', 'tuta.io', 'gmail.co.uk', 'email.com', 'inbox.com', 'live.fr',
]);

/** İki dizi arasındaki düzenleme uzaklığı (yer değiştirme dahil) */
const editDistance = (a, b) => {
  const rows = a.length + 1;
  const cols = b.length + 1;
  const d = Array.from({ length: rows }, (_, i) => {
    const row = new Array(cols).fill(0);
    row[0] = i;
    return row;
  });
  for (let j = 0; j < cols; j += 1) d[0][j] = j;
  for (let i = 1; i < rows; i += 1) {
    for (let j = 1; j < cols; j += 1) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      d[i][j] = Math.min(d[i - 1][j] + 1, d[i][j - 1] + 1, d[i - 1][j - 1] + cost);
      if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) {
        d[i][j] = Math.min(d[i][j], d[i - 2][j - 2] + 1);
      }
    }
  }
  return d[a.length][b.length];
};

/**
 * Alan adı popüler bir sağlayıcının yazım hatasına benziyorsa düzeltilmiş adresi döner, yoksa null.
 * Kısa alan adlarında tek harf, uzunlarda en fazla iki harf fark kabul edilir.
 */
export const suggestEmailFix = (value) => {
  const email = String(value ?? '').trim();
  const at = email.lastIndexOf('@');
  if (at < 1 || at === email.length - 1) return null;
  const local = email.slice(0, at);
  const domain = email.slice(at + 1).toLowerCase().replace(/\.+$/, '');
  if (!domain || KNOWN_DOMAINS.has(domain)) return null;

  let best = null;
  let bestDistance = Infinity;
  POPULAR_DOMAINS.forEach((candidate) => {
    const distance = editDistance(domain, candidate);
    const limit = candidate.length <= 8 ? 1 : 2;
    if (distance <= limit && distance < bestDistance) {
      best = candidate;
      bestDistance = distance;
    }
  });
  return best ? `${local}@${best}` : null;
};
